document.addEventListener('DOMContentLoaded', () => {
  // ── Nav dropdowns with hover delay ─────────────────
  document.querySelectorAll('.nav__item').forEach(item => {
    const dropdown = item.querySelector('.nav__dropdown');
    if (!dropdown) return;
    let closeTimer;

    const open = () => {
      clearTimeout(closeTimer);
      // Close all other dropdowns first
      document.querySelectorAll('.nav__dropdown.is-open').forEach(d => {
        if (d !== dropdown) d.classList.remove('is-open');
      });
      dropdown.classList.add('is-open');
    };

    const close = () => {
      closeTimer = setTimeout(() => {
        dropdown.classList.remove('is-open');
      }, 300); // 300ms grace period
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    dropdown.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    dropdown.addEventListener('mouseleave', close);
  });

  // Close dropdowns when clicking elsewhere
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav__item')) {
      document.querySelectorAll('.nav__dropdown.is-open').forEach(d => d.classList.remove('is-open'));
    }
  });


  // ── Slideshow ──────────────────────────────────────
  const hero = document.querySelector('.hero');
  if (hero) {
    const track  = hero.querySelector('.hero__track');
    const slides = hero.querySelectorAll('.hero__slide');
    const dots   = hero.querySelectorAll('.hero__dot');
    const prev   = hero.querySelector('.hero__prev');
    const next   = hero.querySelector('.hero__next');
    if (track && slides.length > 1) {
      let cur = 0, timer;
      const goTo = i => {
        slides[cur].classList.remove('is-active');
        dots[cur]?.classList.remove('is-active');
        cur = (i + slides.length) % slides.length;
        slides[cur].classList.add('is-active');
        dots[cur]?.classList.add('is-active');
        track.style.transform = `translateX(-${cur * 100}%)`;
      };
      const start = () => { timer = setInterval(() => goTo(cur + 1), 5500); };
      const stop  = () => clearInterval(timer);
      goTo(0); start();
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      prev?.addEventListener('click', () => { stop(); goTo(cur - 1); start(); });
      next?.addEventListener('click', () => { stop(); goTo(cur + 1); start(); });
      dots.forEach((d, i) => d.addEventListener('click', () => { stop(); goTo(i); start(); }));
      let sx = 0;
      track.addEventListener('touchstart', e => { sx = e.touches[0].clientX; stop(); }, { passive: true });
      track.addEventListener('touchend', e => {
        if (Math.abs(e.changedTouches[0].clientX - sx) > 50) goTo(e.changedTouches[0].clientX < sx ? cur + 1 : cur - 1);
        start();
      });
    }
  }

  // ── Mobile nav ─────────────────────────────────────
  const mobileNav = document.querySelector('.mobile-nav');
  const hamburger = document.querySelector('.hamburger');
  const closeBtn  = document.querySelector('.mobile-nav__close');
  hamburger?.addEventListener('click', () => { mobileNav?.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  const closeNav = () => { mobileNav?.classList.remove('is-open'); document.body.style.overflow = ''; };
  closeBtn?.addEventListener('click', closeNav);
  mobileNav?.addEventListener('click', e => { if (e.target === mobileNav) closeNav(); });

  // Mobile accordion
  mobileNav?.querySelectorAll('[data-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      if (sub) sub.style.display = sub.style.display === 'block' ? 'none' : 'block';
    });
  });

  // ── Gallery thumbnails ──────────────────────────────
  document.querySelectorAll('.gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery__thumb').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const main = document.querySelector('.gallery__main img');
      if (main) {
        main.style.opacity = '0';
        setTimeout(() => { main.src = thumb.querySelector('img').src; main.style.opacity = '1'; main.style.transition = 'opacity 0.2s'; }, 160);
      }
    });
  });

  // ── Qty stepper ─────────────────────────────────────
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-field')?.querySelector('.qty-input');
      if (!input) return;
      let v = parseInt(input.value) || 1;
      input.value = btn.dataset.action === 'minus' ? Math.max(1, v - 1) : v + 1;
    });
  });

  // ── Cart count ──────────────────────────────────────
  const updateCart = async () => {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-count');
      if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
    } catch (_) {}
  };
  updateCart();

  // ── Add to cart ─────────────────────────────────────
  const atcForm = document.querySelector('.product-form');
  atcForm?.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = atcForm.querySelector('.atc-btn');
    const orig = btn.innerHTML;
    btn.innerHTML = '✓ Added!';
    btn.style.background = '#1a7a1a';
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', body: new FormData(atcForm) });
      updateCart();
    } catch (_) {}
    setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 2200);
  });

  // ── Newsletter ──────────────────────────────────────
  document.querySelector('.newsletter__form')?.addEventListener('submit', e => {
    e.preventDefault();
    const btn = e.target.querySelector('.newsletter__btn');
    btn.textContent = 'Subscribed! ✓';
    btn.style.background = '#1a7a1a';
    setTimeout(() => { btn.textContent = 'Subscribe'; btn.style.background = ''; }, 3000);
  });

});
